import { handleActions } from 'redux-actions';

export default handleActions(
	{
		GET_GIFT_EVENT_LIST_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_GIFT_EVENT_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_PRODUCT_GIFT_EVENT_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_PRODUCT_GIFT_EVENT_SETTING_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		CHECK_QUALIFICATION_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_EVENT_INFO_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),
	},
	{
		activityList: [],
		eventList: [],
		giftInfo: {},
		gift: {
			title: '',
			setting: '',
			threshold: '',
		},
		product: [],
		notMeetProduct: [],
		productId: '',
	},
);



// WEBPACK FOOTER //
// ./src/reducers/event.js